import { IAuthContext } from '../interfaces/IAuthContext'
import { IDataContext } from '../interfaces/IDataContext'
import { IRootState } from '../interfaces/IRootState'

export const initialDataContext: IDataContext = {
   state: null,
   setRootState: null,
   handleMessage: null,
}
export const GetInitialRootState = (): IRootState => {
   return {
      navigationExpanded: false,
      isLoading: false,
      message: null,
      initialLoading: true,
      userAccount: null,
      organisation: null,
      snis: [],
      defaultWorkplace: null,
      protectedAssetGoals: [],
      hasMsalToken: false,
      userAccounts: [],
      posts: null,
      loggedIn: false,
   }
}

export const initialAuthContext: IAuthContext = {
   isLoadingAuth: true,
   isLoggedIn: false,
   login: null,
   logout: null,
   loginType: null,
}
